__turbopack_context__.v({
  "block": "MethodInfoBlock-module-scss-module__PrnW4W__block",
  "column": "MethodInfoBlock-module-scss-module__PrnW4W__column",
  "content": "MethodInfoBlock-module-scss-module__PrnW4W__content",
  "contentColumn": "MethodInfoBlock-module-scss-module__PrnW4W__contentColumn" + " " + "MethodInfoBlock-module-scss-module__PrnW4W__content",
  "contentRow": "MethodInfoBlock-module-scss-module__PrnW4W__contentRow" + " " + "MethodInfoBlock-module-scss-module__PrnW4W__content",
  "grid": "MethodInfoBlock-module-scss-module__PrnW4W__grid",
  "parameterWrapper": "MethodInfoBlock-module-scss-module__PrnW4W__parameterWrapper",
  "space": "MethodInfoBlock-module-scss-module__PrnW4W__space",
  "title": "MethodInfoBlock-module-scss-module__PrnW4W__title",
  "valueName": "MethodInfoBlock-module-scss-module__PrnW4W__valueName",
  "valueType": "MethodInfoBlock-module-scss-module__PrnW4W__valueType",
});
